export default __webpack_public_path__ + "static/media/gallery_00.25f35139.jpg";